<template>
  <div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <SocialSignInButton :provider="'apple'" @click="loginWith('apple')" />
      <SocialSignInButton :provider="'google'" @click="loginWith('google')" />
    </div>
    <WebccFeedbackMessage
      v-if="errorMessage"
      type="error"
      :message="errorMessage"
      class="mt-4"
    />
  </div>
</template>

<script lang="ts" setup>
const trPrefix = 'components.auth.login.socialSignIns.'

const { getErrorMessage } = useAuthError(trPrefix)
const auth = useAuthStore()
const authFlow = useAuthFlow()
const tracking = useTracking()

const errorMessage = ref<string>()

async function loginWith(provider: SocialProvider) {
  tracking.handlers?.auth.loginSocial(provider)
  authFlow.updateState({ authMethod: 'social' })

  try {
    await auth.loginWithProvider(provider)
  } catch (error) {
    if (error instanceof RedirectAuthError)
      return await navigateTo(error.redirectTo, { external: true })
    errorMessage.value = getErrorMessage(error)
  }
}
</script>
